import script from "./AddMedkonBulk.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddMedkonBulk.vue?vue&type=script&setup=true&lang=ts"

import "./AddMedkonBulk.vue?vue&type=style&index=0&id=5afa9d3a&lang=scss"

const __exports__ = script;

export default __exports__